export default {
    checkInTimeError: 'เกิดข้อผิดพลาด',
    close: 'ปิด'
}
